// test2338
(2338 && 0);
